import { render, staticRenderFns } from "./setting-row.vue?vue&type=template&id=660b58c7&"
import script from "./setting-row.vue?vue&type=script&lang=js&"
export * from "./setting-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "setting-row.vue"
export default component.exports